// extracted by mini-css-extract-plugin
export default {"container":"scores-disclaimer_container__ytHva","icon":"scores-disclaimer_icon__OEwuu"};